import React, { Component, Fragment } from 'react'
import { Button, Icon, Select, Divider } from 'antd'
import className from 'classnames'
import _ from 'lodash'

export default class extends Component {
  state = {
    active: false,
    disabled: false,
    search: null
  }

  handleClick = () => {
    this.setState(state => ({
      active: !state.active,
      search: null
    }))
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  setRef = (node) => {
    this.ref = node
  }

  handleClickOutside = (event) => {
    const { disabled } = this.state
    if (!disabled && this.ref && !this.ref.contains(event.target)) {
      this.setState({ active: false, search: '' })
    }
  }

  handleChange = (id) => {
    this.setState({
      search: null
    })

    this.handleAssignClick(id)
    this.refSelect.blur()
  }

  handleFocus = () => {
    this.setState({
      disabled: true
    })
  }

  handleBlur = () => {
    this.setState({
      disabled: false
    })
  }

  handleAssignClick = (id) => {
    const { table, uploadedTable, addTag, getStorage, updateTable, mode, uploadedFileHandleTag } = this.props

    let promises = []

    if (mode === 'upload') {
      uploadedTable.rows.forEach(file => {
        promises.push(
          addTag(file.guid, id).then(response => {
            if (!response.data.error) {
              return {
                guid: file.guid,
                data: response.data.result
              }
            } else {
              return {
                guid: null,
                data: null
              }
            }
          })
        )
      })
    } else {
      table.rows.forEach(file => {
        promises.push(addTag(file.guid, id))
      })
    }

    Promise.all(promises).then((response) => {
      if (mode === 'upload') {
        response.forEach(i => uploadedFileHandleTag(i.guid, i.data))
      }

      return getStorage()
    }).then(() => {
      updateTable()
    })
  }

  handleDeleteClick = (id) => {
    const { table, uploadedTable, removeTag, getStorage, updateTable, mode, uploadedFileHandleTag } = this.props

    let promises = []

    if (mode === 'upload') {
      uploadedTable.rows.forEach(file => {
        promises.push(
          removeTag(file.guid, id).then(response => {
            if (!response.data.error) {
              return {
                guid: file.guid,
                data: response.data.result
              }
            } else {
              return {
                guid: null,
                data: null
              }
            }
          })
        )
      })
    } else {
      table.rows.forEach(file => {
        promises.push(removeTag(file.guid, id))
      })
    }

    Promise.all(promises).then((response) => {
      if (mode === 'upload') {
        response.forEach(i => uploadedFileHandleTag(i.guid, i.data))
      }

      return getStorage()
    }).then(() => {
      updateTable()
    })
  }

  handleSearch = (value) => {
    this.setState({
      search: value
    })
  }

  handleCreateTag = () => {
    const { search } = this.state
    const { createTag } = this.props

    if (createTag) {
      createTag(search)
    }
  }

  render () {
    const { active, search } = this.state
    const { table, uploadedTable, tags, mode } = this.props

    let selectedTagsArray = []

    if (mode === 'upload') {
      uploadedTable.rows.map(file => selectedTagsArray.push(...file.tags))
    } else {
      table.rows.map(file => selectedTagsArray.push(...file.tags))
    }

    selectedTagsArray = _.uniqBy(selectedTagsArray, e => e.id)

    return (
      <div className={className('dropdown', { 'dropdown_active': active, 'dropdown_top': mode === 'upload' })} ref={this.setRef}>
        <div className='dropdown__head'>
          <Button onClick={this.handleClick}>Assign tags <Icon type='down' /></Button>
        </div>
        <div className='dropdown__content'>
          <div className='dropdown__inner'>
            <div className='assign-tags'>
              <div className='assign-tags__input'>
                <div onMouseDown={(e) => { e.preventDefault(); return false }}>
                  <Select
                    style={{ width: '28rem' }}
                    showSearch
                    defaultActiveFirstOption={false}
                    showArrow={false}
                    value={search}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    onSearch={this.handleSearch}
                    onChange={this.handleChange}
                    notFoundContent={null}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    placeholder='Choose a tag'
                    ref={(n) => (this.refSelect = n)}
                    dropdownRender={menu => <Fragment>
                      { menu }
                      { (search && tags.filter(tag => tag.value.toLowerCase() === search.toLowerCase()).length === 0) && <div>
                        <Divider style={{ margin: '0' }} />
                        <div style={{ padding: '1rem' }}>
                          <Button
                            icon='plus'
                            size='small'
                            type='indigo'
                            onClick={this.handleCreateTag}
                          >Create a new tag</Button>
                        </div>
                      </div>
                      }
                    </Fragment>
                    }
                  >
                    { tags.map(tag =>
                      <Select.Option key={tag.id}>{tag.value}</Select.Option>) }
                  </Select>
                </div>
              </div>
              <div className='assign-tags__list'>
                { !selectedTagsArray.length &&
                  <span>No tags assigned to selected files.</span>
                }
                { selectedTagsArray.map(tag => {
                  let isAssign
                  if (mode === 'upload') {
                    isAssign = uploadedTable.rows.length !== _.filter(uploadedTable.rows, { tags: [ { id: tag.id } ] }).length
                  } else {
                    isAssign = table.rows.length !== _.filter(table.rows, { tags: [ { id: tag.id } ] }).length
                  }

                  return <div className='assign-tags__item' key={tag.id}>
                    <div className='assign-tags__tag'>{ tag.value }</div>
                    <div className='assign-tags__controls'>
                      {
                        isAssign &&
                        <div className='assign-tags__control'>
                          <Button
                            size='small'
                            type='dashed'
                            onClick={() => this.handleAssignClick(tag.id)}
                          ><Icon type='plus' />assign</Button>
                        </div>
                      }
                      <div className='assign-tags__control'>
                        <Button
                          size='small'
                          type='dashed'
                          onClick={() => this.handleDeleteClick(tag.id)}
                        ><Icon type='delete' /></Button>
                      </div>
                    </div>
                  </div>
                }) }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Parts/AssignTags/AssignTags.jsx